/* LIBRAIRIES */
import React, { useState } from 'react';
import { getFirestore, doc, updateDoc } from "firebase/firestore";

/* MUI */
import { Button, Select, MenuItem } from '@mui/material';

/* CONTEXT */
import { useUserContext } from '../../useContext';

/* CSS */
import './ModalModifyUser.css';

/* LOADER */
import { Oval } from 'react-loader-spinner';

const ModalModifyUser = ({ userId, setAlertSeverity, setAlertMessage, setOpenAlert, setRefreshUserList, refreshUserList }) => {

    const { userModifyRole } = useUserContext();
    const [role, setRole] = useState(userModifyRole);
    const [isLoading, setIsLoading] = useState(false);
    const firestore = getFirestore();
    const { setOpenModalModifyUser } = useUserContext();

    const handleChange = (e) => {
        setRole(e.target.value)
    }

    function handleClose() {
        setOpenModalModifyUser(false);
    }

    async function handleClick(e) {
        setIsLoading(true);

        try {
            await updateDoc(doc(firestore, "users", userId), {
                role: role,
            });
                setRefreshUserList(!refreshUserList);
                setAlertSeverity("success");
                setAlertMessage("Le rôle a été mis à jour avec succès !");
                setOpenAlert(true);
                console.log("Le rôle a été mis à jour avec succès !");
        } catch (error) {
                setAlertSeverity("error");
                setAlertMessage("Erreur lors de la mise à jour du rôle :", error)
                setOpenAlert(true);
                console.error("Erreur lors de la mise à jour du rôle :", error);
        } finally {
            setIsLoading(false);
            setOpenModalModifyUser(false);
        }
    };
      
    return (
        <div className='container-modal-modify-user'>
            <div className='content-modal-modify-user'>
                <h1 className='title-modal-modify-user' style={{fontSize: '16px', fontWeight: 'bold'}}>Changer le role d'un utilisateur</h1>              
                <Select
                    id="role-select"
                    value={role}
                    onChange={handleChange}
                    sx={{ width: '100%' }} 
                >
                    <MenuItem value="collaborateur">Collaborateur</MenuItem>
                    <MenuItem value="utilisateur">Utilisateur</MenuItem>
                </Select>
                <div className='container-btns-modif-user'>
                    <Button variant="contained" onClick={handleClick} disabled={isLoading}>
                    {
                            isLoading ?
                            <Oval
                                height={25}
                                width={25}
                                color="var(--primary)"
                                wrapperStyle={{}}
                                wrapperClass=""
                                visible={true}
                                ariaLabel='oval-loading'
                                secondaryColor="#4fa94d"
                                strokeWidth={2}
                                strokeWidthSecondary={2}
                                />
                            :
                            'Confirmer'
                        }
                    </Button>
                    {
                        !isLoading && <Button variant="contained" onClick={handleClose}>Fermer</Button>
                    }
                    
                </div>
            </div>
        </div>
    )
}

export default ModalModifyUser;